import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Synopsis`}</h3>
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/install-ci-test.js */
    }
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm install-ci-test

alias: cit
`}</code></pre>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/install-ci-test.js */
    }
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS END */
    }
    <h3>{`Description`}</h3>
    <p>{`This command runs `}<inlineCode parentName="p">{`npm ci`}</inlineCode>{` followed immediately by `}<inlineCode parentName="p">{`npm test`}</inlineCode>{`.`}</p>
    <h3>{`Configuration`}</h3>
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`save`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: `}<inlineCode parentName="li">{`true`}</inlineCode>{` unless when using `}<inlineCode parentName="li">{`npm update`}</inlineCode>{` where it defaults to `}<inlineCode parentName="li">{`false`}</inlineCode></li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Save installed packages to a `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` file as dependencies.`}</p>
    <p>{`When used with the `}<inlineCode parentName="p">{`npm rm`}</inlineCode>{` command, removes the dependency from
`}<inlineCode parentName="p">{`package.json`}</inlineCode>{`.`}</p>
    <p>{`Will also prevent writing to `}<inlineCode parentName="p">{`package-lock.json`}</inlineCode>{` if set to `}<inlineCode parentName="p">{`false`}</inlineCode>{`.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`save-exact`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Dependencies saved to package.json will be configured with an exact version
rather than using npm's default semver range operator.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`global`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Operates in "global" mode, so that packages are installed into the `}<inlineCode parentName="p">{`prefix`}</inlineCode>{`
folder instead of the current working directory. See
`}<a parentName="p" {...{
        "href": "/cli/v8/configuring-npm/folders"
      }}>{`folders`}</a>{` for more on the differences in behavior.`}</p>
    <ul>
      <li parentName="ul">{`packages are installed into the `}<inlineCode parentName="li">{`{prefix}/lib/node_modules`}</inlineCode>{` folder, instead
of the current working directory.`}</li>
      <li parentName="ul">{`bin files are linked to `}<inlineCode parentName="li">{`{prefix}/bin`}</inlineCode></li>
      <li parentName="ul">{`man pages are linked to `}<inlineCode parentName="li">{`{prefix}/share/man`}</inlineCode></li>
    </ul>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`global-style`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Causes npm to install the package into your local `}<inlineCode parentName="p">{`node_modules`}</inlineCode>{` folder with
the same layout it uses with the global `}<inlineCode parentName="p">{`node_modules`}</inlineCode>{` folder. Only your
direct dependencies will show in `}<inlineCode parentName="p">{`node_modules`}</inlineCode>{` and everything they depend
on will be flattened in their `}<inlineCode parentName="p">{`node_modules`}</inlineCode>{` folders. This obviously will
eliminate some deduping. If used with `}<inlineCode parentName="p">{`legacy-bundling`}</inlineCode>{`, `}<inlineCode parentName="p">{`legacy-bundling`}</inlineCode>{`
will be preferred.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`legacy-bundling`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Causes npm to install the package such that versions of npm prior to 1.4,
such as the one included with node 0.8, can install the package. This
eliminates all automatic deduping. If used with `}<inlineCode parentName="p">{`global-style`}</inlineCode>{` this option
will be preferred.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`omit`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: 'dev' if the `}<inlineCode parentName="li">{`NODE_ENV`}</inlineCode>{` environment variable is set to
'production', otherwise empty.`}</li>
      <li parentName="ul">{`Type: "dev", "optional", or "peer" (can be set multiple times)`}</li>
    </ul>
    <p>{`Dependency types to omit from the installation tree on disk.`}</p>
    <p>{`Note that these dependencies `}<em parentName="p">{`are`}</em>{` still resolved and added to the
`}<inlineCode parentName="p">{`package-lock.json`}</inlineCode>{` or `}<inlineCode parentName="p">{`npm-shrinkwrap.json`}</inlineCode>{` file. They are just not
physically installed on disk.`}</p>
    <p>{`If a package type appears in both the `}<inlineCode parentName="p">{`--include`}</inlineCode>{` and `}<inlineCode parentName="p">{`--omit`}</inlineCode>{` lists, then
it will be included.`}</p>
    <p>{`If the resulting omit list includes `}<inlineCode parentName="p">{`'dev'`}</inlineCode>{`, then the `}<inlineCode parentName="p">{`NODE_ENV`}</inlineCode>{` environment
variable will be set to `}<inlineCode parentName="p">{`'production'`}</inlineCode>{` for all lifecycle scripts.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`strict-peer-deps`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`If set to `}<inlineCode parentName="p">{`true`}</inlineCode>{`, and `}<inlineCode parentName="p">{`--legacy-peer-deps`}</inlineCode>{` is not set, then `}<em parentName="p">{`any`}</em>{`
conflicting `}<inlineCode parentName="p">{`peerDependencies`}</inlineCode>{` will be treated as an install failure, even
if npm could reasonably guess the appropriate resolution based on non-peer
dependency relationships.`}</p>
    <p>{`By default, conflicting `}<inlineCode parentName="p">{`peerDependencies`}</inlineCode>{` deep in the dependency graph will
be resolved using the nearest non-peer dependency specification, even if
doing so will result in some packages receiving a peer dependency outside
the range set in their package's `}<inlineCode parentName="p">{`peerDependencies`}</inlineCode>{` object.`}</p>
    <p>{`When such and override is performed, a warning is printed, explaining the
conflict and the packages involved. If `}<inlineCode parentName="p">{`--strict-peer-deps`}</inlineCode>{` is set, then
this warning is treated as a failure.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`package-lock`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: true`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`If set to false, then ignore `}<inlineCode parentName="p">{`package-lock.json`}</inlineCode>{` files when installing. This
will also prevent `}<em parentName="p">{`writing`}</em>{` `}<inlineCode parentName="p">{`package-lock.json`}</inlineCode>{` if `}<inlineCode parentName="p">{`save`}</inlineCode>{` is true.`}</p>
    <p>{`This configuration does not affect `}<inlineCode parentName="p">{`npm ci`}</inlineCode>{`.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`foreground-scripts`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Run all build scripts (ie, `}<inlineCode parentName="p">{`preinstall`}</inlineCode>{`, `}<inlineCode parentName="p">{`install`}</inlineCode>{`, and `}<inlineCode parentName="p">{`postinstall`}</inlineCode>{`)
scripts for installed packages in the foreground process, sharing standard
input, output, and error with the main npm process.`}</p>
    <p>{`Note that this will generally make installs run slower, and be much noisier,
but can be useful for debugging.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`ignore-scripts`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`If true, npm does not run scripts specified in package.json files.`}</p>
    <p>{`Note that commands explicitly intended to run a particular script, such as
`}<inlineCode parentName="p">{`npm start`}</inlineCode>{`, `}<inlineCode parentName="p">{`npm stop`}</inlineCode>{`, `}<inlineCode parentName="p">{`npm restart`}</inlineCode>{`, `}<inlineCode parentName="p">{`npm test`}</inlineCode>{`, and `}<inlineCode parentName="p">{`npm run-script`}</inlineCode>{`
will still run their intended script if `}<inlineCode parentName="p">{`ignore-scripts`}</inlineCode>{` is set, but they
will `}<em parentName="p">{`not`}</em>{` run any pre- or post-scripts.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`audit`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: true`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`When "true" submit audit reports alongside the current npm command to the
default registry and all registries configured for scopes. See the
documentation for `}<a parentName="p" {...{
        "href": "/cli/v8/commands/npm-audit"
      }}><inlineCode parentName="a">{`npm audit`}</inlineCode></a>{` for details on what is
submitted.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`bin-links`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: true`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Tells npm to create symlinks (or `}<inlineCode parentName="p">{`.cmd`}</inlineCode>{` shims on Windows) for package
executables.`}</p>
    <p>{`Set to false to have it not do this. This can be used to work around the
fact that some file systems don't support symlinks, even on ostensibly Unix
systems.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`fund`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: true`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`When "true" displays the message at the end of each `}<inlineCode parentName="p">{`npm install`}</inlineCode>{`
acknowledging the number of dependencies looking for funding. See `}<a parentName="p" {...{
        "href": "/cli/v8/commands/npm-fund"
      }}><inlineCode parentName="a">{`npm
fund`}</inlineCode></a>{` for details.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`dry-run`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Indicates that you don't want npm to make any changes and that it should
only report what it would have done. This can be passed into any of the
commands that modify your local installation, eg, `}<inlineCode parentName="p">{`install`}</inlineCode>{`, `}<inlineCode parentName="p">{`update`}</inlineCode>{`,
`}<inlineCode parentName="p">{`dedupe`}</inlineCode>{`, `}<inlineCode parentName="p">{`uninstall`}</inlineCode>{`, as well as `}<inlineCode parentName="p">{`pack`}</inlineCode>{` and `}<inlineCode parentName="p">{`publish`}</inlineCode>{`.`}</p>
    <p>{`Note: This is NOT honored by other network related commands, eg `}<inlineCode parentName="p">{`dist-tags`}</inlineCode>{`,
`}<inlineCode parentName="p">{`owner`}</inlineCode>{`, etc.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`workspace`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default:`}</li>
      <li parentName="ul">{`Type: String (can be set multiple times)`}</li>
    </ul>
    <p>{`Enable running a command in the context of the configured workspaces of the
current project while filtering by running only the workspaces defined by
this configuration option.`}</p>
    <p>{`Valid values for the `}<inlineCode parentName="p">{`workspace`}</inlineCode>{` config are either:`}</p>
    <ul>
      <li parentName="ul">{`Workspace names`}</li>
      <li parentName="ul">{`Path to a workspace directory`}</li>
      <li parentName="ul">{`Path to a parent workspace directory (will result in selecting all
workspaces within that folder)`}</li>
    </ul>
    <p>{`When set for the `}<inlineCode parentName="p">{`npm init`}</inlineCode>{` command, this may be set to the folder of a
workspace which does not yet exist, to create the folder and set it up as a
brand new workspace within the project.`}</p>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`workspaces`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: null`}</li>
      <li parentName="ul">{`Type: null or Boolean`}</li>
    </ul>
    <p>{`Set to true to run the command in the context of `}<strong parentName="p">{`all`}</strong>{` configured
workspaces.`}</p>
    <p>{`Explicitly setting this to false will cause commands like `}<inlineCode parentName="p">{`install`}</inlineCode>{` to
ignore workspaces altogether. When not set explicitly:`}</p>
    <ul>
      <li parentName="ul">{`Commands that operate on the `}<inlineCode parentName="li">{`node_modules`}</inlineCode>{` tree (install, update, etc.)
will link workspaces into the `}<inlineCode parentName="li">{`node_modules`}</inlineCode>{` folder. - Commands that do
other things (test, exec, publish, etc.) will operate on the root project,
`}<em parentName="li">{`unless`}</em>{` one or more workspaces are specified in the `}<inlineCode parentName="li">{`workspace`}</inlineCode>{` config.`}</li>
    </ul>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`include-workspace-root`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Include the workspace root when workspaces are enabled for a command.`}</p>
    <p>{`When false, specifying individual workspaces via the `}<inlineCode parentName="p">{`workspace`}</inlineCode>{` config, or
all workspaces via the `}<inlineCode parentName="p">{`workspaces`}</inlineCode>{` flag, will cause npm to operate only on
the specified workspaces, and not on the root project.`}</p>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`install-links`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`When set file: protocol dependencies that exist outside of the project root
will be packed and installed as regular dependencies instead of creating a
symlink. This option has no effect on workspaces.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS END */
    }
    <h3>{`See Also`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-install-test"
        }}>{`npm install-test`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-ci"
        }}>{`npm ci`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-test"
        }}>{`npm test`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      